import { ref } from 'vue'

import Shepherd from 'shepherd.js'

import { ConfigStateViewModel } from '@/presentation/viewmodels/config/configStateViewModel'

export class IntroPresenter {
  private configStateViewModel: ConfigStateViewModel
  isExitIntro = ref(false)

  constructor(configStateViewModel: ConfigStateViewModel = new ConfigStateViewModel()) {
    this.configStateViewModel = configStateViewModel
  }

  setIsExitIntro = (value: boolean) => {
    this.isExitIntro.value = value
  }

  private addStep = (
    tour: Shepherd.Tour,
    id: string,
    text: string,
    element: string,
    position: Shepherd.Step.PopperPlacement,
    classes: string
  ) => {
    tour.addStep({
      id: id,
      modalOverlayOpeningRadius: 5,
      classes: classes,
      attachTo: { element: element, on: position },
      text: text,
      canClickTarget: false,
      buttons: [
        {
          text: 'Back',
          action: tour.back
        },
        {
          text: 'Next',
          action: tour.next
        }
      ]
    })
  }

  startTour = () => {
    this.isExitIntro.value = false

    const tour = new Shepherd.Tour({
      useModalOverlay: true,
      defaultStepOptions: {
        classes: 'shepherd-theme-custom',
        cancelIcon: {
          enabled: true
        }
      }
    })
    tour.addStep({
      id: 'step1',
      text:
        this.configStateViewModel.displayLanguage.value == 'Japanese'
          ? 'Aizu Online Judge 3.0へようこそ！<br>これから基本的な使い方について説明します。'
          : 'Welcome to AOJ 3.0!<br>We will now explain the basic usage of AOJ-ICE.',
      buttons: [
        {
          text: 'Next',
          action: tour.next
        }
      ]
    })
    this.addStep(
      tour,
      'step2',
      this.configStateViewModel.displayLanguage.value == 'Japanese'
        ? 'はじめに興味のある問題を探してみましょう。'
        : 'First, find a problem that interests you.',

      '#problemSearch',
      'bottom',
      'mt-5'
    )
    this.addStep(
      tour,
      'step3',
      this.configStateViewModel.displayLanguage.value == 'Japanese'
        ? '問題を選んだら、問題文を読みましょう。'
        : 'After choosing a problem, read the text of the problem.',
      '#problem',
      'right',
      'ml-5'
    )
    this.addStep(
      tour,
      'step4',
      this.configStateViewModel.displayLanguage.value == 'Japanese'
        ? '問題文を読んだら、解答プログラムを作成しましょう。'
        : 'After reading the problem, create an answer program.',
      '#editor',
      'left',
      'shepherd-margin-right'
    )
    this.addStep(
      tour,
      'step5',
      this.configStateViewModel.displayLanguage.value == 'Japanese'
        ? 'テストするための入力値を設定しましょう。'
        : "Let's set the input value to test.",
      '#input',
      'top',
      'shepherd-margin-bottom'
    )
    this.addStep(
      tour,
      'step6',
      this.configStateViewModel.displayLanguage.value == 'Japanese'
        ? '入力値を元に、想定される出力値を設定しましょう。'
        : "Let's set the expected output value based on the input value.",
      '#expect-output',
      'top',
      'shepherd-margin-bottom'
    )
    this.addStep(
      tour,
      'step7',
      this.configStateViewModel.displayLanguage.value == 'Japanese'
        ? 'このボタンをクリックすると、あなたが作成したプログラムのテストができます。'
        : 'Click this button to test your program.',
      '#testButton',
      'left',
      'shepherd-margin-right'
    )
    this.addStep(
      tour,
      'step8',
      this.configStateViewModel.displayLanguage.value == 'Japanese'
        ? 'ここにテスト結果が表示されます。<br>この出力と想定出力が一致するように解答プログラムを修正しましょう。'
        : "Here you can see the test results. <br>Let's modify the answer program so that this output matches the expected output.",
      '#output',
      'top',
      'shepherd-margin-bottom'
    )
    this.addStep(
      tour,
      'step9',
      this.configStateViewModel.displayLanguage.value == 'Japanese'
        ? 'このボタンをクリックすると、AOJにプログラムが提出されます。'
        : 'Click this button to submit your program to the AOJ.',
      '#submitButton',
      'left',
      'shepherd-margin-right'
    )
    this.addStep(
      tour,
      'step10',
      this.configStateViewModel.displayLanguage.value == 'Japanese'
        ? '「ジャッジの詳細」には、あなたがAOJに提出した結果が表示されます。'
        : '"Judge Detail" shows the results you submitted to the AOJ.',
      '#judge',
      'left',
      'shepherd-margin-right'
    )
    this.addStep(
      tour,
      'step11',
      this.configStateViewModel.displayLanguage.value == 'Japanese'
        ? 'メニューには、あなたがプログラミング学習をより効果的に進めるための各種機能が備わっています。'
        : 'The menu has various functions for you to advance programming learning more effectively.',
      '#header',
      'bottom',
      'mt-5'
    )
    this.addStep(
      tour,
      'step12',
      this.configStateViewModel.displayLanguage.value == 'Japanese'
        ? 'レビュー機能を使用することで、レビュアーからプログラムに含まれるバグや改善点に関するフィードバックを得ることができます。'
        : 'Review allows you to get feedback from reviewers on bugs and improvements in your program.',
      '#review',
      'right',
      'ml-5'
    )
    tour.addStep({
      id: 'step13',
      text:
        this.configStateViewModel.displayLanguage.value == 'Japanese'
          ? '以上がAOJ-ICEの基本的な使い方についての説明でした。<br>AOJ-ICEを活用して、プログラミングにチャレンジしてみましょう！'
          : 'That was the explanation of the basic usage of AOJ-ICE. <br>Try programming with AOJ-ICE!',
      buttons: [
        {
          text: 'Back',
          action: tour.back
        },
        {
          text: 'Done',
          action: tour.next
        }
      ]
    })
    tour.start()
    tour.on('cancel', () => {
      this.isExitIntro.value = true
      document.cookie = 'showIntro=true; max-age=2147483647'
    })
    tour.on('complete', () => {
      this.isExitIntro.value = true
      document.cookie = 'showIntro=true; max-age=2147483647'
    })
  }
}
